import React from "react";

import { Alert, Snackbar } from "@mui/material";

const Error = (props) => {
  const { error = {}, vertical = "top", horizontal = "center" } = props;

  const origin = {
    vertical: vertical,
    horizontal: horizontal,
  };

  return (
    <Snackbar open={true} anchorOrigin={origin}>
      <Alert variant="filled" severity="error">
        {error.message}
      </Alert>
    </Snackbar>
  );
};

export default Error;
